import UpgradedKits from 'components/business/UpgradedKits';
import React from 'react';

function UpgradedKitsPages() {
  return (
    <UpgradedKits />
  );
}

export default UpgradedKitsPages;
